module.exports = __webpack_public_path__ + "img/outlander001.38d10768.jpg";